const routes = [
  {
    path: '/fitsummit',
    redirect: { name: 'fit-summit-sign-in' }
  },
  {
    path: '/fitsummit/sign-in',
    name: 'fit-summit-sign-in',
    component: () => import('../views/SignInView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/fitsummit/introduction',
    name: 'fit-summit-intro-page',
    component: () => import('../views/IntroPageView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/fitsummit/workout',
    component: () => import('../views/Workout.vue'),
    beforeEnter: checkUserLogin,
    props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy:"BP" }),
    name: "fit-summit-workout",
  },
  {
    path: '/fitsummit/safety-precautions',
    name: 'fit-summit-safety-precautions',
    component: () => import('../views/SafetyPrecautionsView.vue'),
    props: route => ({ tenantName: route.query.tenantName, id: route.query.id }),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/fitsummit/user-details',
    name: 'fit-summit-user-details',
    component: () => import('../views/UserDetailsView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/fitsummit/leaderboard',
    name: 'fit-summit-leaderboard',
    component: () => import('../views/LeaderBoardView.vue'),
    beforeEnter: checkUserLogin,
  },
]

function checkUserLogin(to, from, next) {
  const isAnonymous = localStorage.getItem('login') ? (JSON.parse(localStorage.getItem('login'))).isAnonymous : true;
  if (isAnonymous) {
    if (to.name == 'fit-summit-sign-in')
      next()
    else
      next({ name: 'fit-summit-sign-in' });
  }
  else {
    if (to.name == 'fit-summit-sign-in') {
      next({ name: 'fit-summit-intro-page' });
    }
    else {
      next();
    }
  }
}

export default routes;